"use client";
import { useEffect, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import ModalIconTitle from "../ModalIconTitle";
import { IoLocationOutline } from "react-icons/io5";
import { useI18n } from "../../i18n";

type MapModalProp = {
  placeName: string;
  address: string;
  show: boolean;
  onClose: () => void;
};

export default function MapModal({
  placeName,
  address,
  show,
  onClose,
}: MapModalProp) {
  const [modalTitle, setModalTitle] = useState("");
  const { t } = useI18n();
  useEffect(() => {
    if (!placeName || placeName.toString().trim().length === 0) return;
    setModalTitle(t("common.map") + " - " + placeName.toString().trim());
  }, [placeName]);

  const onHide = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      dialogClassName={"modal-75w"}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <ModalIconTitle
            title={modalTitle}
            iconElement={<IoLocationOutline />}
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <iframe
            title={placeName}
            src={`https://www.google.com/maps?q=${address}&output=embed`}
            loading="lazy"
            style={{ minHeight: `75vh` }}
          ></iframe>
        </Row>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
